"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.triaConnected = exports.wagmiConnectedAsync = exports.wagmiConnected = exports.createIframe = exports.createEncodedData = void 0;
const createEncodedData = (data) => {
    const encodedParams = btoa(JSON.stringify(data));
    return encodedParams;
};
exports.createEncodedData = createEncodedData;
const createIframe = (iframeUrl, hookName) => {
    const iframeContainer = document.createElement('div');
    iframeContainer.id = hookName;
    iframeContainer.className = 'bg flex justify-between bg-transparent fixed bottom-4 right-2';
    const position = JSON.parse(localStorage.getItem('wallet.position') || '{}');
    const posTop = position === null || position === void 0 ? void 0 : position.posY;
    const posLeft = position === null || position === void 0 ? void 0 : position.posX;
    iframeContainer.style.zIndex = '9999';
    iframeContainer.style.position = 'fixed';
    iframeContainer.style.top = `${posTop}px`;
    iframeContainer.style.left = `${posLeft}px`;
    const innerContainer = document.createElement('div');
    innerContainer.className = 'mb-4 mr-2 relative rounded-[20px]';
    const iframeWrapper = document.createElement('div');
    iframeWrapper.className = 'h-[586px] w-[312px] rounded-[20px] overflow-hidden';
    const iframe = document.createElement('iframe');
    iframe.width = '312';
    iframe.height = '586';
    iframe.src = iframeUrl;
    iframe.allow = 'publickey-credentials-get';
    iframe.style.border = 'none';
    // Append elements to construct the desired structure
    iframeWrapper.appendChild(iframe);
    innerContainer.appendChild(iframeWrapper);
    iframeContainer.appendChild(innerContainer);
    // Append iframeContainer to the document body or a specific container
    document.body.appendChild(iframeContainer);
    // Return any relevant data if needed
};
exports.createIframe = createIframe;
const wagmiConnected = () => {
    const value = localStorage.getItem('wagmi.connected');
    if (value == 'true')
        return true;
    else
        return false;
};
exports.wagmiConnected = wagmiConnected;
const wagmiConnectedAsync = () => __awaiter(void 0, void 0, void 0, function* () {
    //@ts-ignore
    const { getAccount } = yield Promise.resolve().then(() => __importStar(require('wagmi/actions')));
    const { isConnected, address } = getAccount();
    return { isConnected, address: address };
});
exports.wagmiConnectedAsync = wagmiConnectedAsync;
const triaConnected = () => {
    const value = localStorage.getItem('tria.wallet.store');
    if (value)
        return true;
    else
        return false;
};
exports.triaConnected = triaConnected;
